import WebServiceRequest from "@/libs/Api/WebServiceRequest";

class GetAllTermicCourses extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("TermicCourses/GetAll");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class CreateTermicCourse extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("TermicCourses/Create");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class UpdateTermicCourse extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("TermicCourses/UpdateTermicCourseByAdmin");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class ChangeTermicCourseStatusToAvailable extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("TermicCourses/ChangeStatusToAvailableCapacityByAdmin");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class StartTermicCourse extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("TermicCourses/StartTermicCourseByAdmin");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class CancelTermicCourse extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("TermicCourses/CanceledTermicCourse");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class FinishTermicCourse extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("TermicCourses/FinishTermicCourseByAdmin");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class GetTermicCourseById extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("TermicCourses/GetById");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class GetSignedUpStudentsForTermicCourse extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("TermicCourses/GetSignedUpTermicCourseStudents");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

export {
  GetAllTermicCourses,
  CreateTermicCourse,
  UpdateTermicCourse,
  ChangeTermicCourseStatusToAvailable,
  StartTermicCourse,
  CancelTermicCourse,
  FinishTermicCourse,
  GetTermicCourseById,
  GetSignedUpStudentsForTermicCourse,
};
